import BaseItem, { Rarity } from './base_item';

export default class VacuumCleaner extends BaseItem {
    constructor(x, y) {
        super(x, y, "items", "vacuum_cleaner.png");
    }

    //this is width/height of collision box (attached to bottom)
    static get width() { return 8;}
    static get height() { return 8;}

    static get mass() { return 2;}
    static get electronic() { return true; }
    static get rarity() { return Rarity.COMMON; }

    static get type() { return 'vacuum_cleaner'}
    static get label() { return 'vacuum cleaner'}
    static get description() { return `It's a vacuum cleaner. You know, for cleaning vacuum.`}
}


// WEBPACK FOOTER //
// ./src/objects/items/vacuum_cleaner.js